import ComponentHelper from '../../../../supers/ComponentHelper';
import React from 'react';
import InputField from '../../../../components/input-field/InputField';
import ValidationService from '../../../../services/ValidationService';
import { view } from 'react-easy-state';
import MultiStepModal from '../../../../components/multi-step-modal/MultiStepModal';
import _ from 'lodash';
import './resolver-modal.css';
import Dropdown from '../../../../components/dropdown/Dropdown';
import RESTService from '../../../../services/RESTService';
import RoutingService from '../../../../services/RoutingService';
import Spinner from '../../../../components/spinner/Spinner';
const VS = new ValidationService();
const connect = new RESTService();
const RS = new RoutingService();

// MODEL = store({
//     name: '',
//     type: '',
//     fieldType: 'string',
//     fieldName: '',
//     resolver: {
//         type: 'field',
//         endpoint: '',
//         args: {}
//     }
// });

class ResolverModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.autoBindAll(this, null, true);
		this.setInitialData(props);
	}

	setInitialData(props) {
		this.data = props.formData;
		this.data.entities = props.entities;
		this.data.editing = props.editing;
		this.data.endpoints = props.endpoints;
		this.data.isMutator = props.isMutator;
		this.data.loading = false;
		if (this.data.editing) {
			this.data.editing = JSON.parse(JSON.stringify(this.data.editing));
			let old = this.data.editing;
			this.data.displayName = old.displayName;
			this.data.type = old.type;
			this.data.resolver = old.resolver;
		}
	}

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		}
	}

	onClose() {
		this.props.onClose();
	}

	onNameChange(evt) {
		if (evt.target.name === 'displayName' && VS.validateQueryName(evt.target.value)) {
			this.data[evt.target.name] = evt.target.value;
		} else if (evt.target.name !== 'displayName' && VS.validateField(evt.target.value)) {
			this.data[evt.target.name] = evt.target.value;
		}
	}

	onEntityChange(newVal) {
		if (newVal) this.data.type = newVal.value;
	}

	onEndpointChange(newVal) {
		if (newVal) this.data.resolver.endpoint = newVal.value;
	}

	onResultTypeChange(newVal) {
		if (newVal) this.data.resolver.type = newVal.value;
	}

	onTypeChange(newVal) {
		if (newVal) this.data.fieldType = newVal.value;
	}

	validateStep1() {
		if (this.data.displayName.length > 0 && this.data.type.length > 0) {
			return true;
		}
		return false;
	}

	validateStepM() {
		if (this.data.displayName.length > 0 && this.data.type.length > 0 && this.data.resolver.endpoint.length > 0) {
			return true;
		}
		return false;
	}

	validateStep2() {
		let { type, endpoint } = this.data.resolver;
		if (type.length > 0 && endpoint.length > 0) {
			return true;
		}
		return false;
	}

	onSaveResolver() {
		let promise = null;
		if (this.props.editing) {
			let name = this.props.editing.name;
			let resolver = JSON.parse(JSON.stringify(this.data.resolver));
			let { displayName, type } = this.data;
			if (this.data.isMutator) {
				promise = connect.updateMutator({
					name,
					displayName,
					type,
					resolver
				});
			} else {
				promise = connect.updateResolver({
					name,
					displayName,
					type,
					resolver
				});
			}
		} else {
			let { displayName, type, resolver } = this.data;
			if (this.data.isMutator) {
				promise = connect.createMutator({
					displayName,
					type,
					resolver
				});
			} else {
				promise = connect.createResolver({
					displayName,
					type,
					resolver
				});
			}
		}
		if (promise) {
			this.data.loading = true;
			promise
				.then(() => {
					this.data.loading = false;
					RS.showSuccess();
					this.props.onComplete();
				})
				.catch(err => {
					this.data.loading = false;
					RS.smartError(err);
				});
		}
	}

	getEntities() {
		let ents = this.data.entities;
		let items = [];
		_.forEach(ents, entity => {
			items.push({
				value: `${entity.name}`,
				label: entity.displayName
			});
		});
		return items;
	}

	getEndpoints() {
		let eps = this.data.endpoints;
		let items = [];
		_.forEach(eps, ep => {
			items.push({
				value: ep.name,
				label: ep.name
			});
		});
		return items;
	}

	getTypes() {
		let items = [];
		let types = ['string', 'number', 'integer', 'boolean'];
		_.forEach(types, type => {
			items.push({
				value: type,
				label: _.upperFirst(type)
			});
		});
		return items;
	}

	validField() {
		return this.data.fieldType.length > 0 && this.data.fieldName.length > 0;
	}

	addField() {
		let { fieldName, fieldType, resolver } = this.data;
		if (fieldName.length > 0 && fieldType.length > 0) {
			resolver.args[fieldName] = { type: fieldType };
			this.data.fieldName = '';
			this.data.fieldType = 'string';
		}
	}

	keyPress(evt) {
		if (evt.key === 'Enter' && this.validField()) {
			evt.preventDefault();
			this.addField();
		}
	}

	getSteps() {
		let { displayName, type, resolver, fieldName, fieldType, loading } = this.data;
		if (loading) {
			return {
				Saving: {
					validator: null,
					onNext: null,
					text: '',
					nextText: '',
					loading: true,
					content: <Spinner text="Saving..." />
				}
			};
		}
		if (this.data.isMutator) {
			return {
				'Mutator Setup': {
					validator: this.validateStepM,
					onNext: this.onSaveResolver,
					text: 'What should we call this mutator?',
					nextText: 'Save',
					content: (
						<div className="modal-body">
							<InputField
								label="Mutator Name"
								name="displayName"
								type="text"
								value={displayName}
								handleChange={this.onNameChange}
								placeholder="Enter a unique name"
								disabled={this.data.editing ? true : false}
								required
								autoFocus
							/>
							<Dropdown
								className="type-picker"
								label="Entity Type"
								value={type}
								placeholder="Select Entity"
								handleChange={this.onEntityChange}
								name="typePicker"
								subText="What entity will this resolve to?"
								options={this.getEntities()}
								required
							/>
							<Dropdown
								className="type-picker"
								label="Endpoint"
								value={resolver.endpoint}
								placeholder="Select Endpoint"
								handleChange={this.onEndpointChange}
								name="typePicker"
								options={this.getEndpoints()}
								required
							/>
						</div>
					)
				}
			};
		} else {
			return {
				'Name & Type': {
					validator: this.validateStep1,
					onNext: null,
					text: 'What should we call this resolver?',
					nextText: 'Next',
					content: (
						<div className="modal-body">
							<InputField
								label="Resolver Name"
								name="displayName"
								type="text"
								value={displayName}
								handleChange={this.onNameChange}
								placeholder="Enter a unique name"
								disabled={this.data.editing ? true : false}
								required
								autoFocus
							/>
							<Dropdown
								className="type-picker"
								label="Entity Type"
								value={type}
								placeholder="Select Entity"
								handleChange={this.onEntityChange}
								name="typePicker"
								subText="What entity will this resolve to?"
								options={this.getEntities()}
								required
							/>
						</div>
					)
				},
				Data: {
					validator: this.validateStep2,
					onNext: this.onSaveResolver,
					text: 'What endpoint resolves the data?',
					nextText: 'Save',
					content: (
						<div className="modal-body">
							<Dropdown
								className="type-picker"
								label="Endpoint"
								value={resolver.endpoint}
								placeholder="Select Endpoint"
								handleChange={this.onEndpointChange}
								name="typePicker"
								options={this.getEndpoints()}
								required
							/>
							<Dropdown
								className="type-picker"
								label="Resolved Data Type"
								value={resolver.type}
								handleChange={this.onResultTypeChange}
								name="typePicker"
								required
								options={[
									{
										value: 'field',
										label: 'Single Object'
									},
									{
										value: 'connection',
										label: 'Multiple Objects'
									}
								]}
							/>
							<div className={`endpoint-details ${resolver.endpoint.length > 0 ? '' : 'hide-me'}`}>
								<div className="header-label">Endpoint Arguments</div>
								<div className="arg-controls hbox">
									<InputField
										label="Field Name"
										name="fieldName"
										type="text"
										value={fieldName}
										handleChange={this.onNameChange}
										onKeyDown={this.keyPress}
										placeholder="Enter a unique name"
										className="m-r-10"
									/>
									<Dropdown
										className="type-picker"
										label="Field Type"
										value={fieldType}
										placeholder="Select type"
										handleChange={this.onTypeChange}
										name="typePicker"
										options={this.getTypes()}
									/>
									<button
										className="btn primary square add-btn vbox hcenter vcenter"
										disabled={!this.validField()}
										title="Add Field"
										onClick={this.addField}
									>
										<i className="mdi mdi-plus" />
									</button>
								</div>
								{this.getArguments()}
							</div>
						</div>
					)
				}
			};
		}
	}

	getArguments() {
		let { resolver: { args } } = this.data;
		let fields = [];
		_.forEach(Object.keys(args), field => {
			fields.push(
				<div className="field-row hbox vcenter" key={field + '-key'}>
					<div className="field-name ellipse">{field}</div>
					<div className="field-type grow-1">{_.upperFirst(args[field].type)}</div>
					<i className="mdi mdi-close" title="Remove" data-field={field} onClick={this.removeField} />
				</div>
			);
		});
		if (fields.length <= 0) {
			fields.push(
				<div className="empty-msg" key="empty-msg-key-0">
					Enter a name and type above to add arguments if required.
				</div>
			);
		}
		return <div className="fields-list">{fields}</div>;
	}

	removeField(evt) {
		delete this.data.resolver.args[evt.target.dataset.field];
	}

	render() {
		let { isOpen, title } = this.props;
		return <MultiStepModal isOpen={isOpen} onClose={this.onClose} className="resolver-modal" title={title} steps={this.getSteps()} />;
	}
}
export default view(ResolverModal);



// WEBPACK FOOTER //
// ./src/views/entities-panel/resolver-list/resolver-modal/ResolverModal.js